module.exports = __webpack_public_path__ + "static/media/khimki_logo.14f00820.png";